<div class="update-additional-driver modify-pickup">

  <div class="row m-0">
    <div class="col-lg-5 col-md-6 left-modal-side">
      <div class="left-modal-side-padding Update-Driver-Title">
        <h3 mat-dialog-title >{{  'UpdateDriverInformation' | translate  }}</h3>
        <ng-container *ngIf="true">
          <div class="update-driver-modal mr-4 ">
              <driver-update (onCancel)="cancelClicked()"  (onDriverUpdated)="saveSuccessful()"></driver-update>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 modal-card ">

      <vehicle-card-for-modal [vehicle]="vehicle"></vehicle-card-for-modal>
    </div>
    <ng-container *ngIf="true">
    <div class="col-lg-4 col-md-12 modify-booking-charge-summary">
      <!--charge summery view-->
      <charge-summary-view-booking ></charge-summary-view-booking>
    </div>
    </ng-container>
  </div>
</div>


